<vectronic-card
  [title]="'Edit Columns'"
  [displayClose]="true"
  [headerIconButtons]="headerIconButtons"
  (closed)="dialogRef.close()"
>
  <ng-container body class="card-body">
    <div class="column-filters" cdkDropListGroup>
      <div class="column-filters__container" cdkScrollable>
        <h2 class="column-filters__title">Visible columns</h2>
        <div
          cdkDropList
          [cdkDropListData]="visibleColumns"
          class="column-filters__list column-filters__list--visible"
          (cdkDropListDropped)="drop($event)"
        >
          @for (item of visibleColumns; track item) {
            <div class="column-filters__box" cdkDrag>
              <mat-icon>drag_handle</mat-icon>
              {{ item.headerName }}
            </div>
          }
        </div>
      </div>

      <div class="column-filters__container" cdkScrollable>
        <h2 class="column-filters__title">Hidden columns</h2>

        <div
          cdkDropList
          [cdkDropListData]="hiddenColumns"
          class="column-filters__list column-filters__list--hidden"
          (cdkDropListDropped)="drop($event)"
        >
          @for (item of hiddenColumns; track item) {
            <div class="column-filters__box" cdkDrag>
              <mat-icon>drag_handle</mat-icon>
              {{ item.headerName }}
            </div>
          }
        </div>
      </div>
    </div>
  </ng-container>
</vectronic-card>
